import React, { useContext, useCallback, useRef } from 'react';
import { AppDataContext } from 'contexts/appData';
import { useEventListener, usePreventBodyScroll } from 'libs';
import { useLocation, useNavigate } from 'react-router-dom';

const ProfileEditIframeModal = (props) => {
  const { callback } = props;
  const { api, CONFIG } = useContext(AppDataContext);
  const location = useLocation()
  const fromPath = location.state?.from

  const iframeRef = useRef(null)


  const navigate = useNavigate();
  usePreventBodyScroll();

  const accessToken = api.cookie._get(CONFIG.CACHE.TAGS.COOKIEAUTH);

  const iframeUrl = `${process.env.REACT_APP_AUTH_URL}ka/user/edit-profile?Continue=${encodeURIComponent(window.location.origin)}&Token=${accessToken}`;

  const close = () => {
    callback?.({}, 'destroy');
  };

  const handleMessage = useCallback((e) => {
    if (String(e.origin + '/') === process.env.REACT_APP_AUTH_URL) {

      const parsedData = JSON.parse(e.data);
      if (parsedData?.eventData === 'closeModal') {
        if (fromPath) {
          navigate(fromPath)
          close()
        } else {
          navigate(-1)
        }
      }

      if (parsedData?.eventData === 'requestToken' && iframeRef.current?.contentWindow) {
        try {
          iframeRef.current.contentWindow.postMessage({ type: 'AUTH_TOKEN', token: accessToken }, process.env.REACT_APP_AUTH_URL);
        } catch (e) {
          console.error('Failed to send access token', e);
        }
      }
    }
  }, [accessToken]);

  // Listen for messages
  useEventListener('message', handleMessage);

  return (
    <div className="h-100">
      <iframe
        title="Edit Profile"
        className="w-100 h-100 border-0"
        src={iframeUrl}
        ref={iframeRef}
      />
    </div>
  );
};

export default ProfileEditIframeModal;
